import { publicClient, privateClient } from './client';
import { GuestIdentity } from './GuestIdentity';

const transactionsGuestIdentity = (pub: boolean) => new GuestIdentity(pub ? publicClient : privateClient);
export default transactionsGuestIdentity;
